export default String.raw`
.set-amount-popup {
    height: fit-content;
    min-height: 316px;
    
    &__content {
        flex-direction: column;

        &-left {
            &-info {
                display: flex;
                flex-direction: column;
                row-gap: 16px;
            }
        }

        &-text {
            &-title {
                display: none;
            }

            &-numbers {
                &-amount {
                    &-price {
                        display: none;
                    }
                }
            }
        }
    }

    &__buttons {
        flex-direction: column-reverse;
        row-gap: 12px;
        justify-content: center;
    }
}
`